const util = require('util');

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December'];

function padAfter(valPassed, length, paddingCharacter) {
  const val = String(valPassed);
  if (val.length >= length) {
    return val;
  }
  const result = val + (new Array(length).join(paddingCharacter) + paddingCharacter);
  return result.substring(0, length);
}

function padBefore(valPassed, length, paddingCharacter) {
  const val = String(valPassed);
  if (val.length >= length) {
    return val;
  }
  const result = (new Array(length).join(paddingCharacter) + paddingCharacter) + val;
  return result.substring(result.length - length);
}

/**
 * Formats a date according to a provided pattern.  The pattern is intended to be compatible with
 * the Java SimpleDateFormatter.
 * @param {string} pattern the pattern, see the Java SimpleDataFormatter patterns.
 * @param {Date} date the date
 * @returns {string} the provided date formatted according to the provided pattern
 */
function dateFormat(pattern, date = new Date()) {
  const dayNo = date.getDay();
  const dateNo = date.getDate();
  const month = date.getMonth();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const sec = date.getSeconds();
  const millis = date.getMilliseconds();
  const fullYear = date.getFullYear();

  return pattern
    .replace(/HH/g, padBefore(hour, 2, '0'))
    .replace(/H/g, hour)
    .replace(/mm/g, padBefore(minute, 2, '0'))
    .replace(/m/g, minute)
    .replace(/ss/g, padBefore(sec, 2, '0'))
    .replace(/s/g, sec)
    .replace(/SSS/g, padBefore(millis, 3, '0'))
    .replace(/S/g, millis)
    .replace(/yyyy/g, fullYear)
    .replace(/yy/g, String(fullYear).substring(2))
    .replace(/dd/g, padBefore(dateNo, 2, '0'))
    .replace(/d/g, dateNo)
    .replace(/MMMM/g, MONTH_NAMES[month])
    .replace(/MMM/g, MONTH_NAMES[month].substring(0, 3))
    .replace(/MM/g, padBefore(month + 1, 2, '0'))
    .replace(/M/g, month + 1)
    .replace(/EEEE/g, DAY_NAMES[dayNo])
    .replace(/EEE/g, DAY_NAMES[dayNo].substring(0, 3));
}

/**
 * A default formatter to convert log events to strings.
 * @param {Date} time time
 * @param {string} component component
 * @param {string} level level
 * @param {*[]} data whatever
 * @returns {string} stuff
 */
function templateFormatter(time, component, level) {
  const date = new Date(time);
  const formattedDate = dateFormat('yyyy-MM-dd HH:mm:ss.SSS', date);
  const paddedLevel = padAfter(level, 5, ' ');
  const paddedComponent = padAfter(component, 18, ' ');
  return `${formattedDate} [${paddedLevel}] [${paddedComponent}]:`;
}

// see http://en.wikipedia.org/wiki/ANSI_escape_code
// this is to make the output nicer in the node console.
const colors = {
  black: 0, red: 1, green: 2, yellow: 3, blue: 4, magenta: 5, cyan: 6, white: 7,
};

function style(str, styleObj) {
  const startCodes = [];
  const endCodes = [];
  for (const key of Object.keys(styleObj)) {
    const value = styleObj[key];
    const styleParts = value.split(' ');
    const color = styleParts[styleParts.length - 1];
    const isBright = styleParts[0] === 'bright';
    let base = null;
    if (key === 'color') {
      base = 30;
    } else if (key === 'background') {
      base = 40;
    }
    startCodes.push(`\x1B[${base + colors[color]}${isBright ? ';1m' : 'm'}`);
    endCodes.push(`\x1B[${(base + 9)}${isBright ? ';22m' : 'm'}`);
  }
  return startCodes.join('') + str + endCodes.reverse().join('');
}

const LEVEL_STYLES = {
  fatal: { color: 'bright white', background: 'bright red' },
  error: { color: 'bright red' },
  warn: { color: 'bright yellow' },
  info: {},
  debug: { color: 'green' },
};

/**
 * A formatter that converts log events to ansi colored strings.
 * @param {number} time time
 * @param {string} component component
 * @param {string} level level
 * @param {*} data data
 * @returns {string} ansiformatted
 */
function ansiFormatter(time, component, level) {
  const date = new Date(time);
  const formattedDate = dateFormat('yyyy-MM-dd HH:mm:ss.SSS', date);
  const paddedLevel = padAfter(level, 5, ' ');
  const paddedComponent = padAfter(component, 18, ' ');
  const styledPrefix = style(`${formattedDate} [${paddedLevel}] [${paddedComponent}]`,
    LEVEL_STYLES[level]);

  return `${styledPrefix}:`;
}

// If we're outputting to a node terminal, then use ANSI color codes to make the
// log output prettier.
const inTerm = (global.process && global.process.stdout && Boolean(global.process.stdout.isTTY));
const defaultFormatter = inTerm ? ansiFormatter : templateFormatter;
if (inTerm && util.inspect) {
  util.inspect.defaultOptions.colors = true;
}

module.exports = {
  dateFormat,
  templateFormatter,
  ansiFormatter,
  defaultFormatter,
};
